import { ErrorOutline } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { Button } from '@ifs-gcp/components';

import { ROUTE_SUPPLIERS_DASHBOARD } from '@/constants/router';

import styles from './pending-page.module.scss';

interface PendingPageProps {
  supplierId: string;
}

export const PendingPage = ({ supplierId }: PendingPageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <h6 className={styles.title}>{t('dashboard.pending_modal.title')}</h6>
        <ErrorOutline className={styles.icon} />
        <p className={styles.description}>{t('dashboard.pending_modal.text')}</p>

        <Button
          variant="contained"
          color="secondary"
          onClick={() => {
            navigate(ROUTE_SUPPLIERS_DASHBOARD(supplierId));
          }}
        >
          {t('actions.go_to_dashboard')}
        </Button>
      </div>
    </div>
  );
};
